import { Box } from '@mui/material';
import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';
import { breakpoints } from 'styles/breakpoints';

type WhispersBundleProps = {
  backgroundSrc: any;
  backgroundColor: any;
  bundleBorderColor: any;
};

export const StyledWhispersBundle = styled.div<WhispersBundleProps>`
  box-sizing: border-box;
  border-radius: 12px;
  background: ${(props: any) => createGradientOrSolid(props.bundleBorderColor)};
  font-family: var(--font-family), Arial;
  width: 100%;
  padding: 2px;
  position: relative;

  &:before {
    content: '';
    display: block;
    padding-top: 137.037037%;
  }

  .container {
    background: ${({ backgroundSrc, backgroundColor }: any) =>
      backgroundSrc
        ? `url("${backgroundSrc}")`
        : createGradientOrSolid(backgroundColor)};
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: absolute;
    top: 2px;
    left: 2px;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
  }
`;

export const StyledPriceBeforeSale = styled(Box)`
  position: absolute;
  display: flex;
  bottom: 3%;
  left: 50%;
  transform: translateX(-50%);
  color: #959394;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: line-through;
  text-decoration-thickness: 1.5px;
  direction: ${(props: any) => props.direction};
  justify-content: center;
  width: 100%;

  .actual-price {
    direction: ltr;
  }
` as any;

export const StyledWhisperEmblemBadge = styled.div`
  position: absolute;
  right: -2px;
  top: -2px;
  background-image: url(${(props: any) => props.badgeImage});
  background-repeat: no-repeat;
  z-index: 1000;
  max-width: 67px;

  width: 45%;

  @media (width <= ${breakpoints.tablet}) {
    top: -4px;
  }

  img {
    object-fit: contain;
    width: 100%;
  }
`;

export const StyledProductImageContainer = styled.div`
  position: absolute;
  height: 38%;
  left: 50%;
  top: 14%;
  transform: translateX(-50%);
  img {
    object-fit: contain;
    height: 100%;
    width: auto;
  }

  @media (width < ${breakpoints.tablet}) {
    top: 12%;
  }
`;
